import styled from 'styled-components';

export const TOOLTIP_DEFAULT_MIN_WIDTH = '300px';

export type CoordinateProps = {
  type: 'coordinates';
};

export const CoordinatePropertiesStyled = styled.div`
  display: grid;
  grid-column-gap: 50px;
  grid-row-gap: 10px;

  p {
    margin: 0;

    label {
      display: block;
      white-space: nowrap;
      text-align: left;
      color: #fffa;
      font-size: 0.9em;
      margin-bottom: 0.2em;
    }

    span {
      white-space: nowrap;
    }
  }

  .northing {
    grid-area: northing;
  }

  .easting {
    grid-area: easting;
  }

  .coordinate-system {
    grid-area: coordinate-system;
  }

  .mas {
    grid-area: mas;
    margin-top: 0.5em;
    border-top: 1px solid #fffa;
    padding-top: 2em;
  }
`;
